/* MV124 (perf v8) — perf v6 with one line changed: it idle-loads
   mavely-i18n.v6 (v5 plus the Spanish and French words for the new "High
   Score" / "Low Score" buttons). Nothing else changed; v6 is still on disk.
   (perf v7 is a different file, already in use.) */
/* MV119 (perf v6) — mavely-perf.v3 with one line changed: it idle-loads
   mavely-i18n.v5 instead of v4 (v5 no longer re-scans the whole page on
   every change while the page is in English — see that file). Everything
   else, groupcalc included, is v3 byte for byte, except that image and
   section positions are read from an IntersectionObserver instead of
   getBoundingClientRect() (which forced a whole-page layout on every
   pass). v3 is still on disk. */
/*!
 * mavely-perf.v2.js — v96
 * ===========================================================================
 * ADDITIVE. mavely-perf.v1.min.js is still loaded and still does its job
 * (lazy-loading the two admin scripts). This file sits alongside it and does
 * not touch anything v1 handles.
 *
 * WHAT LIGHTHOUSE IS COMPLAINING ABOUT, AND WHAT THIS ANSWERS
 * ---------------------------------------------------------------------------
 *   "Reduce unused JavaScript — 175 KiB"
 *   "Reduce JavaScript execution time — 2.3 s"
 *   "Minimize main-thread work — 4.2 s"
 *
 * Two files are a large share of that and neither is needed to paint the page
 * or to shorten a link:
 *
 *   mavely-i18n.v4.min.js      57 KB   Spanish + French translations
 *   mavely-groupcalc.v4.min.js 27 KB   the Group Score tab
 *
 * Both were `defer`, which means they still download during page load,
 * still parse, and still run before the page is interactive. 84 KB of parse
 * and execute for two features most visitors never touch.
 *
 * This loads them when the browser is idle instead, or immediately if the
 * visitor does something that needs them. Nothing is removed, nothing changes
 * behaviour — they arrive a fraction of a second later.
 *
 * TO TURN IT OFF: delete the <script> tag for this file from index.html and
 * put the two original tags back. They are still on disk.
 * ===========================================================================
 */
(function () {
  'use strict';

  if (window.__MAVELY_PERF_V2__) return;
  window.__MAVELY_PERF_V2__ = true;

  /* Files v1 already owns. Never touch these — v1 loads the admin bundle on
     its own schedule and two loaders racing would double-run it. */
  var DEFERRED = [
    { src: '/assets/mavely-i18n.v6.min.js',      flag: '__MV_I18N_LOADED' },
    { src: '/assets/mavely-groupcalc.v4.min.js', flag: '__MV_GROUPCALC_LOADED' }
  ];

  var loaded = false;

  function loadDeferred(why) {
    if (loaded) return;
    loaded = true;

    DEFERRED.forEach(function (d, i) {
      if (window[d.flag]) return;
      if (document.querySelector('script[src="' + d.src + '"]')) return;

      /* Staggered so the two do not parse in the same frame — that stagger is
         most of the main-thread win, not the delay itself. */
      setTimeout(function () {
        var s = document.createElement('script');
        s.src = d.src;
        s.async = true;
        s.onload = function () { window[d.flag] = true; };
        document.head.appendChild(s);
      }, i * 120);
    });

    if (window.console && console.debug) {
      console.debug('[mavely-perf] v2 loaded deferred scripts (' + why + ')');
    }
  }

  /* ---- 1. when the browser has nothing better to do ---------------------- */
  function scheduleIdle() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { loadDeferred('idle'); }, { timeout: 4000 });
    } else {
      setTimeout(function () { loadDeferred('timeout'); }, 2500);
    }
  }

  /* ---- 2. or the moment the visitor needs them --------------------------- */
  // A language button, or the Group Score tab, must work on the first click
  // even if idle time has not arrived yet. Capture phase, so this runs before
  // the feature's own handler.
  function onEarlyInteraction(e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var el = t.closest('button, a, [role="tab"]');
    if (!el) return;

    var txt = (el.textContent || '').trim().toUpperCase();
    if (txt.indexOf('GROUP') !== -1 || txt.length <= 3 /* EN / AR / ES / FR */) {
      loadDeferred('interaction');
    }
  }
  document.addEventListener('pointerdown', onEarlyInteraction, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') loadDeferred('keyboard');
  }, true);

  /* ---- 3. images ---------------------------------------------------------- */
  /*
   * "Improve image delivery — Est savings of 1,964 KiB" is mostly content.png,
   * and tools/make-webp.php is what fixes that. This is the smaller half:
   * deal thumbnails below the fold are decoded on the main thread during load
   * even though nobody has scrolled to them.
   *
   * decoding="async" moves that decode off the critical path. loading="lazy"
   * stops the request entirely until it is near the viewport. Applied only to
   * images that are BELOW the fold — a lazy LCP image makes things worse, not
   * better, which is the usual way this optimisation backfires.
   */
  /* MV119: positions come from an IntersectionObserver, after the browser's
     own layout, instead of getBoundingClientRect() in the middle of the
     frame (each pass forced a layout of the whole page). The tests and the
     attributes/classes they set are unchanged; they land one frame later.
     Without IntersectionObserver the old code path runs. */
  var mvIO = null;
  try {
    if ('IntersectionObserver' in window) {
      mvIO = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          var t = entries[k].target, top = entries[k].boundingClientRect.top;
          /* the viewport height as the observer measured it: reading
             window.innerHeight can itself force a layout */
          var rb = entries[k].rootBounds, vh = (rb && rb.height) || window.innerHeight || 800;
          mvIO.unobserve(t);
          if (t.tagName === 'IMG') tuneApply(t, top, vh);
          else if (top > vh * 1.5) t.classList.add('mv-cv-auto');
        }
      });
    }
  } catch (e) { mvIO = null; }

  function tuneApply(img, top, vh) {
    var fold = vh || 800;
    if (top > fold) {
      if (!img.hasAttribute('loading')) img.loading = 'lazy';
    } else if (!img.hasAttribute('fetchpriority') && top < fold * 0.6) {
      img.setAttribute('fetchpriority', 'high');
    }
  }

  function tuneImages(root) {
    var imgs = (root || document).querySelectorAll('img:not([data-mv-tuned])');
    var fold = mvIO ? 0 : (window.innerHeight || 800);  // MV119: innerHeight can force a layout

    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.setAttribute('data-mv-tuned', '1');

      if (mvIO) {                                        // MV119
        if (!img.hasAttribute('decoding')) img.decoding = 'async';
        mvIO.observe(img);
        continue;
      }

      var top;
      try { top = img.getBoundingClientRect().top; } catch (e) { top = fold + 1; }

      if (!img.hasAttribute('decoding')) img.decoding = 'async';

      if (top > fold) {
        if (!img.hasAttribute('loading')) img.loading = 'lazy';
      } else if (!img.hasAttribute('fetchpriority') && top < fold * 0.6) {
        // Near the top: tell the browser this one matters. Helps LCP.
        img.setAttribute('fetchpriority', 'high');
      }
    }
  }

  /* ---- 4. offscreen sections --------------------------------------------- */
  /*
   * content-visibility:auto lets the browser skip layout and paint for
   * sections that are scrolled out of view. On a page with a long deals grid
   * that is a direct cut to "Minimize main-thread work".
   *
   * contain-intrinsic-size gives each skipped section a placeholder height so
   * the scrollbar does not jump — without it this causes layout shift, which
   * is the usual way THIS optimisation backfires.
   */
  function addContentVisibility() {
    if (document.getElementById('mv-perf-v2-css')) return;
    var css = document.createElement('style');
    css.id = 'mv-perf-v2-css';
    css.textContent =
      '@supports (content-visibility: auto) {' +
      '  .mv-cv-auto { content-visibility: auto; contain-intrinsic-size: auto 420px; }' +
      '}';
    document.head.appendChild(css);
  }

  function markOffscreenSections() {
    var fold = mvIO ? 0 : (window.innerHeight || 800) * 1.5;  // MV119: see tuneImages
    var cards = document.querySelectorAll('[class*="grid"] > div:not([data-mv-cv])');

    for (var i = 0; i < cards.length; i++) {
      var el = cards[i];
      el.setAttribute('data-mv-cv', '1');
      if (mvIO) { mvIO.observe(el); continue; }         // MV119
      var top;
      try { top = el.getBoundingClientRect().top; } catch (e) { continue; }
      if (top > fold) el.classList.add('mv-cv-auto');
    }
  }

  /* ---- wiring ------------------------------------------------------------ */
  function start() {
    addContentVisibility();
    tuneImages();
    markOffscreenSections();
    scheduleIdle();

    /* The app is React and renders its content after this file runs, so a
       one-shot pass is not enough. Observed rather than polled, and throttled
       to one pass per animation frame so the observer itself cannot become
       the main-thread cost it is meant to reduce. */
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          tuneImages();
          markOffscreenSections();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Console escape hatch, matching v1's __mvLoadAdmin(). */
  window.__mvLoadDeferred = function () { loadDeferred('manual'); };

  if (window.console && console.info) console.info('[mavely-perf] v2 ready');
})();
